<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/18XRILC/tc-custom/1.png?1638240517167?1731166528805" alt="This image is the cover for the book The Girl Who Misses Her Dad"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Girl Who Misses Her Dad
      </h1>
      <p class="bookDescription body article font2">
        <p>Kukua was born to Mr and Mrs Brew in Accra, Ghana in August, 1986. She was left in the care of her grandmother as both parents left Ghana to seek a better future for the family. Kukua did not see her dad until she was 13 years old. Ekua (Kukua) beautifully evokes her childhood with her grandmother and the little precious years she got to spend with her father before he passed away.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ekua Brew
      </h2>
      
      <p class="authorDescription body article">Ekua Brew who was affectionately known as Kukua was born and raised in Accra, Ghana until the age of 17 when she joined her mother in London. She attended the university of Portsmouth, where she gained a degree in Human Physiology. Ekua Brew has two children, Stella and Samuel and currently lives in London.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4601ea38